import type Controller from '@ember/controller';
import Route from '@ember/routing/route';
import type Transition from '@ember/routing/transition';
import { service } from '@ember/service';

import type { Service } from 'webapp-types';

export interface GenieThreadModel {
	threadId: string;
}

export default class GenieChatThreadRoute extends Route {
	@service('ai-chat') declare aiChatService: Service.AIChat;
	@service('navigation') declare navigationService: Service.Navigation;
	@service('genie-thread-agency-return')
	declare genieThreadAgencyReturnService: Service.GenieThreadAgencyReturn;

	override beforeModel(transition: Transition): void {
		const threadId = this.genieThreadAgencyReturnService.threadIdFromTransition(transition);

		if (
			this.genieThreadAgencyReturnService.showErrorIfForeignSourceThread(
				threadId,
				'This conversation is not available in this account.',
			)
		) {
			this.navigationService.replaceRoute('genie');
		}
	}

	override model(params: { thread_id: string }): GenieThreadModel {
		const { thread_id } = params;
		return { threadId: thread_id };
	}

	override setupController(controller: Controller, model: GenieThreadModel): void {
		super.setupController(controller, model);

		// Drive the controlled `threadId` from the URL into the React mount (hard load + live nav).
		this.aiChatService.applyUrlThread(model.threadId);
		// Entering a thread clears any artifact left over from the previous one. The child
		// genie.chat.thread.artifact route sets its own id right after this, so a deep link is unaffected;
		// navigating within one thread doesn't re-enter here, so it can't clobber the open artifact.
		this.aiChatService.applyUrlArtifact(null);
	}
}
